module.exports = __webpack_public_path__ + "static/img/erweima.2dc08c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima.png
// module id = hMRt
// module chunks = 8